import { ApolloCache } from 'apollo-cache';
import { GetAlertsQuery } from './queries';
import { addAlert, removeAlert } from './services';
import { AlertColor, AlertMessage } from './types';

export const defaults: { alerts: AlertMessage[] } = {
    alerts: []
};

/** Local resolvers handling client alerts */
export const resolvers = {
    Mutation: {
        addAlert: (
            _: any,
            { message, color }: { message: string; color?: AlertColor },
            { cache }: { cache: ApolloCache<any> }
        ) => addAlert({ message, color }, cache),
        clearAlerts: (
            _: any,
            { message }: { message: string },
            { cache }: { cache: any }
        ) => {
            cache.writeData({ data: { alerts: [] } });
        },
        removeAlert: (
            _: any,
            { message }: { message: string; color?: AlertColor },
            { cache }: { cache: ApolloCache<any> }
        ) => removeAlert({ message }, cache)
    },
    Query: {
        alerts: (_: any, args: any, { cache }: { cache: any }) => {
            const data = cache.readQuery({ query: GetAlertsQuery });

            return { alerts: data.alerts };
        }
    }
};



// WEBPACK FOOTER //
// ./src/client/clientState/alerts/resolvers.ts